import { createStyles, makeStyles, Theme } from '@material-ui/core';


const MediaPreviewStyles = makeStyles(({ palette }: Theme) => createStyles({
  button: {
    background: 'rgba(0,0,0,0.8)',
    '&:hover': {
      background: palette.buttonSingle.color,
    },
  },
  icon: {
    color: '#FFF',
  },
  closeButton: {
    color: '#FFF',
    textTransform: 'unset',
    fontSize: 16,
    minWidth: 36,
    '&:hover': {
      background: 'rgba(255,255,255,0.15)',
    },
  },
  groupAction: {
    background: 'unset',
    border: 'solid 1px #FFF',
    color: '#FFF',
    '& span:hover': {
      background: 'rgba(255,255,255,0.15)',
    },
  },
  select: {
    width: 100,
    background: 'unset',
    border: 'solid 1px #FFF',
    color: '#FFF',
    '& span:hover': {
      background: 'rgba(255,255,255,0.15)',
    },
  },
}), { name: 'MediaPreviewAction' });

export default MediaPreviewStyles;
